import styled from 'styled-components';

// Wrapper that doesn't affect Grid layout with ref - children behave as direct Grid children
export const FocusContainer = styled.div`
    display: contents;
`;
